define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Format = (function () {
        function Format() {
        }
        return Format;
    }());
    exports.Format = Format;
});
//# sourceMappingURL=Format.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Format.js
// module id = 373
// module chunks = 0